import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import $ from 'jquery'

gsap.registerPlugin(ScrollTrigger)

const animateMission = () => {
  let isScreenChange = false
  const timelineMission = gsap.timeline({
    scrollTrigger: {
      trigger: '#mission',
      pin: true,
      scrub: 1,
      start: 'top top',
      end: '+300%',
    },
  })

  timelineMission
    .set('.mission__bg', { clipPath: 'circle(0%)' })
    .set(['.about-us__title', '.about-us__subtitle', '.about-us__bigtitle', '.about-us__caption'], {
      opacity: 0,
    })
    .set('.about-us__modal', {
      visibility: 'hidden',
      opacity: 0,
    })
    .set('.about-us__button', {
      opacity: 0,
      scale: 0,
    })
    .to(
      '.mission__top',
      {
        duration: 3,
        y: `-${$('.mission__body').outerHeight() * 1.25}px`,
      },
      0
    )
    .to(
      '.mission__top',
      {
        autoAlpha: 0,
        display: 'none',
      },
      2
    )
    .to(
      '.mission__bg',
      {
        duration: 4,
        delay: '-0.5',
        clipPath: 'circle(100%)',
      },
      2
    )
    .to(
      '.about-us__title',
      {
        autoAlpha: 1,
      },
      2
    )
    .to(
      '.about-us__subtitle',
      {
        autoAlpha: 1,
      },
      2.2
    )
    .to(
      '.about-us__bigtitle',
      {
        autoAlpha: 1,
      },
      2.4
    )
    .to(
      ['.about-us__modal', '.about-us__caption'],
      {
        opacity: 1,
        visibility: 'visible',
        duration: 2.5,
        onComplete: () => {
          if (!isScreenChange) {
            isScreenChange = true
            setInterval(() => {
              $('.mission__image.-bg01').css({
                opacity: '0',
              })
              $('.mission__image.-bg02').css({
                opacity: '1',
              })
              setTimeout(() => {
                $('.mission__image.-bg02').css({
                  opacity: '0',
                })
                $('.mission__image.-bg01').css({
                  opacity: '1',
                })
              }, 2000)
            }, 4000)
          }
        },
      },
      2.6
    )
    .to(
      ['.about-us__modal', '.about-us__caption'],
      {
        autoAlpha: 0,
        visibility: 'hidden',
      },
      5
    )
    .to(
      '.about-us__wrap',
      {
        scale: 0.5,
        autoAlpha: 0,
        force3D: false,
        y: '10%',
      },
      5
    )
    .to(
      '.about-us__wrap',
      {
        scale: 0,
        opacity: 0,
        force3D: false,
      },
      6
    )
    .to(
      '.about-us__button',
      {
        opacity: 1,
        scale: 1,
        force3D: false,
      },
      5
    )
}

export default animateMission
